export default __webpack_public_path__ + "static/media/fish_hover_highlight.b38ba6dc.png";